import React from "react";
import "./walletOverviewSkeleton.css";

function SkeletonRow() {
  return (
    <tr>
      <td>
        <div className="agce-wallet-ov-sk__coin">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-avatar" aria-hidden />
          <div className="agce-wallet-ov-sk__coin-lines">
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-line-a" aria-hidden />
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-line-b" aria-hidden />
          </div>
        </div>
      </td>
      <td className="ta-r">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w80" aria-hidden />
      </td>
      <td className="ta-r">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w72" aria-hidden />
      </td>
      <td className="ta-r">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w52" aria-hidden />
      </td>
      <td className="ta-r">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w72" aria-hidden />
      </td>
      <td className="ta-r">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__pill" aria-hidden />
      </td>
    </tr>
  );
}

function SkeletonTable({ rows = 8 }) {
  return (
    <div className="funding-account__tablewrap table-responsive agce-wallet-ov-sk__tablewrap">
      <table className="funding-account__table agce-wallet-ov-sk__table">
        <thead>
          <tr>
            <th>Coin</th>
            <th className="ta-r">Total Amount</th>
            <th className="ta-r">Available</th>
            <th className="ta-r">In Order</th>
            <th className="ta-r">Avg. Cost Price</th>
            <th className="ta-r">Action</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, i) => (
            <SkeletonRow key={`sk-r-${i}`} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function HeaderActionsAndEstimate() {
  return (
    <>
      <div className="agce-wallet-ov-sk__header-row funding-account__header border-0 pb-0">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__title-bar" aria-hidden />
        <div className="agce-wallet-ov-sk__actions">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
        </div>
      </div>
      <div className="estimated_balance agce-wallet-ov-sk__estimated">
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-label" aria-hidden />
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-lg" aria-hidden />
        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-sm" aria-hidden />
      </div>
    </>
  );
}

/** Shimmer placeholders — Assets Overview (`asset-overview`), Spot (`spot-wallet`), Main (`main-wallet`). */
export default function WalletOverviewSkeleton({ variant = "asset-overview" }) {
  if (variant === "asset-overview") {
    return (
      <div className="dashboard_right agce-wallet-ov-sk" aria-busy="true" aria-label="Loading overview">
        <div className="dashboard_listing_section Overview_mid padding-left">
          <div className="assets_wallets_section">
            <div className="row">
              <div className="col-sm-12 overview_section">
                <HeaderActionsAndEstimate />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="market_section">
                  <div className="coin_view_top agce-wallet-ov-sk__tabs-toolbar">
                    <div className="wallet_tabs agce-wallet-ov-sk__tabs">
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__tab-chip" aria-hidden />
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__tab-chip" aria-hidden />
                    </div>
                    <div className="agce-wallet-ov-sk__toolbar-tools">
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__search-chip" aria-hidden />
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-chip" aria-hidden />
                    </div>
                  </div>
                  <div className="dashboard_summary desktop_view-2">
                    <SkeletonTable rows={8} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (variant === "spot-wallet") {
    return (
      <div
        className="dashboard_right funding-account wallet-page--ao-popup agce-wallet-ov-sk"
        aria-busy="true"
        aria-label="Loading spot wallet"
      >
        <div className="funding-account__header">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__title-bar" aria-hidden />
          <div className="funding-account__header-actions">
            {[0, 1, 2, 3].map((i) => (
              <span key={i} className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__pill-action" aria-hidden />
            ))}
          </div>
        </div>
        <div className="funding-account__toprow">
          <div className="funding-account__totals">
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-label" aria-hidden />
            <div className="funding-account__totals-main" style={{ marginTop: 10 }}>
              <span
                className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-lg"
                style={{ display: "block", marginBottom: 6 }}
                aria-hidden
              />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-sm" style={{ display: "block" }} aria-hidden />
            </div>
          </div>
          <div className="funding-account__spot-pnl">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="agce-wallet-ov-sk__bone funding-account__spot-pnl-sk__title" aria-hidden />
              <div className="cmp-pnl-btn-group">
                {[0, 1, 2, 3].map((i) => (
                  <span key={i} className="agce-wallet-ov-sk__bone funding-account__spot-pnl-sk__period" aria-hidden />
                ))}
              </div>
            </div>
            <div className="funding-account__spot-pnl-sk cmp-pnl-grid">
              {[0, 1, 2].map((i) => (
                <div key={i} className="funding-account__spot-pnl-sk__cell">
                  <span className="agce-wallet-ov-sk__bone funding-account__spot-pnl-sk__label" aria-hidden />
                  <span className="agce-wallet-ov-sk__bone funding-account__spot-pnl-sk__val" aria-hidden />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="funding-account__filters agce-wallet-ov-sk__filters-strip">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__search-wide" aria-hidden />
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-wide" aria-hidden />
        </div>
        <div className="funding-account__hintbar agce-wallet-ov-sk__hintbar">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__hint-line" aria-hidden />
        </div>
        <SkeletonTable rows={7} />
      </div>
    );
  }

  /* ── Isolated Margin Account skeleton ─────────────────────────────────────── */
  if (variant === "margin-account") {
    return (
      <div className="dashboard_right funding-account agce-wallet-ov-sk" aria-busy="true" aria-label="Loading margin account">
        {/* Header */}
        <div className="funding-account__header border-0">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__title-bar" aria-hidden />
          <div className="funding-account__header-actions">
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
          </div>
        </div>

        {/* Summary card */}
        <div className="funding-account__summarycard">
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-label" style={{ marginBottom: 12, display: "block" }} aria-hidden />
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-lg" style={{ display: "block", marginBottom: 8 }} aria-hidden />
          <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-sm" style={{ display: "block", marginBottom: 8 }} aria-hidden />
          <div style={{ display: "flex", gap: 16, marginTop: 12 }}>
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 36, borderRadius: 6 }} aria-hidden />
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 36, borderRadius: 6 }} aria-hidden />
          </div>
        </div>

        {/* Filter bar */}
        <div className="funding-account__card mt-3">
          <div className="funding-account__filters funding-account__filters--tight" style={{ paddingBottom: 12 }}>
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__search-wide" aria-hidden />
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-chip" aria-hidden />
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-chip" aria-hidden />
          </div>

          {/* Table skeleton — 10 cols for the margin account table */}
          <div className="funding-account__tablewrap">
            <table className="funding-account__table agce-wallet-ov-sk__table">
              <thead>
                <tr>
                  {["Pair", "Coin", "Available", "Borrowable", "Loan Cap", "Borrowed", "Frozen", "Net Assets", "Liq. Price", "Action"].map((h) => (
                    <th key={h} className={h === "Pair" || h === "Coin" ? "" : "ta-r"}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 6 }, (_, i) => (
                  <tr key={`msk-${i}`}>
                    <td>
                      <div className="funding-account__coin">
                        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-avatar" aria-hidden />
                        <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-line-a" aria-hidden />
                      </div>
                    </td>
                    <td>
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w52" aria-hidden />
                    </td>
                    {[80, 72, 64, 72, 60, 80, 64].map((w, j) => (
                      <td key={j} className="ta-r">
                        <span className={`agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w${w}`} aria-hidden />
                      </td>
                    ))}
                    <td className="ta-r">
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__pill" aria-hidden />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  /* ── Cross Margin Account skeleton ─────────────────────────────────────────── */
  if (variant === "cross-margin-account") {
    return (
      <div className="dashboard_right funding-account agce-wallet-ov-sk" aria-busy="true" aria-label="Loading cross margin account">
        {/* Header */}
        <div className="funding-account__header border-0">
          <div>
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__title-bar" aria-hidden />
            <span className="agce-wallet-ov-sk__bone" style={{ width: 200, height: 13, borderRadius: 6, marginTop: 6, display: "block" }} aria-hidden />
          </div>
          <div className="funding-account__header-actions">
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
          </div>
        </div>

        {/* Summary card with gauge placeholder */}
        <div className="funding-account__summarycard" style={{ padding: "20px 24px" }}>
          <div className="d-flex align-items-start justify-content-between flex-wrap gap-4">
            {/* Left: balance */}
            <div>
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-label" style={{ display: "block", marginBottom: 10 }} aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-lg" style={{ display: "block", marginBottom: 6 }} aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__est-line-sm" style={{ display: "block" }} aria-hidden />
            </div>
            {/* Centre: gauge placeholder */}
            <div className="d-flex flex-column align-items-center">
              <span className="agce-wallet-ov-sk__bone" style={{ width: 112, height: 80, borderRadius: "50% 50% 0 0 / 50% 50% 0 0" }} aria-hidden />
            </div>
            {/* Right: leverage badge */}
            <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
          </div>
          <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 48, borderRadius: 6 }} aria-hidden />
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 48, borderRadius: 6 }} aria-hidden />
          </div>
          <div style={{ display: "flex", gap: 16, marginTop: 12, borderTop: "1px solid rgba(128,128,128,0.12)", paddingTop: 12 }}>
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 48, borderRadius: 6 }} aria-hidden />
            <span className="agce-wallet-ov-sk__bone" style={{ width: "48%", height: 48, borderRadius: 6 }} aria-hidden />
          </div>
        </div>

        {/* Tabbed card */}
        <div className="funding-account__card mt-3">
          {/* Tab bar skeleton */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 16px", borderBottom: "1px solid rgba(128,128,128,0.15)" }}>
            <div style={{ display: "flex", gap: 8, padding: "12px 0" }}>
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__tab-chip" aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__tab-chip" aria-hidden />
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center", padding: "8px 0" }}>
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__search-chip" aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-chip" aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
              <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__btn-sm" aria-hidden />
            </div>
          </div>

          {/* Table skeleton — 7 cols for Funds tab */}
          <div className="funding-account__tablewrap">
            <table className="funding-account__table agce-wallet-ov-sk__table">
              <thead>
                <tr>
                  {["Coin", "Total Balance", "Available", "Borrowed", "Interest", "Net", "Action"].map((h) => (
                    <th key={h} className={h === "Coin" ? "" : "ta-r"}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 8 }, (_, i) => (
                  <tr key={`csk-${i}`}>
                    <td>
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__coin-line-a" aria-hidden />
                    </td>
                    {[80, 80, 72, 60, 72].map((w, j) => (
                      <td key={j} className="ta-r">
                        <span className={`agce-wallet-ov-sk__bone agce-wallet-ov-sk__cell-num agce-wallet-ov-sk__cell-num--w${w}`} aria-hidden />
                      </td>
                    ))}
                    <td className="ta-r">
                      <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__pill" aria-hidden />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  /* main-wallet */
  return (
    <div
      className="dashboard_right funding-account wallet-nonspot agce-wallet-ov-sk"
      aria-busy="true"
      aria-label="Loading main wallet"
    >
      <div className="overview_section">
        <div className="funding-account__header border-0 pb-0">
          <HeaderActionsAndEstimate />
        </div>

        <div className="dashboard_listing_section Overview_mid">
          <div className="assets_wallets_section">
            <div className="market_section">
              <div className="coin_view_top" style={{ marginBottom: 16 }}>
                <div className="wallet_tabs">
                  <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__tab-chip" aria-hidden />
                </div>
                <div className="coin_right" style={{ display: "flex", gap: 14 }}>
                  <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__search-chip" aria-hidden />
                  <span className="agce-wallet-ov-sk__bone agce-wallet-ov-sk__check-chip" aria-hidden />
                </div>
              </div>
              <div className="dashboard_summary desktop_view-2">
                <SkeletonTable rows={8} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
